import React from 'react';

import { IMfaSessionDetails } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { IReportInfo } from 'src/common/components/report-info/ReportInfo';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { applyMobileLabelDisplayNames } from 'src/common/helpers/LabelDisplayHelpers';

import { MfaSessionLabels } from './MfaSessionLabels';

import './MfaSingleSessionHeader.scss';

export const getMfaInfoItems = (
	unitIdDisplayName?: string,
	environmentDisplayName?: string
): IReportInfo[] => {
	return [
		{
			key: 'lastModified',
			label: 'Last modified',
			textFormatter: formatShortMonthDatetime
		},
		{
			key: 'owner',
			label: 'Owner'
		},
		{
			key: 'labels',
			label: 'Session labels',
			customValueRenderer: (session: IMfaSessionDetails) => {
				const labels = applyMobileLabelDisplayNames(
					session.labels ?? [],
					unitIdDisplayName,
					environmentDisplayName
				);
				return <MfaSessionLabels labels={labels} />;
			}
		}
	];
};
